module.exports = __webpack_public_path__ + "static/media/gagana-books.0bf5a627.png";